module.exports = __webpack_public_path__ + "html/recover_code.0eb7de.html";


/*****************
 ** WEBPACK FOOTER
 ** ../AccountApp/recover_code.html
 ** module id = 705
 ** module chunks = 1
 **/